import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useFormInputDateStyles = makeStyles()((theme: Theme) => ({
	label: {
		marginBottom: theme.spacing(1),
		marginTop: 0,
		fontWeight: theme.typography.fontWeightMedium,
	},
	inputField: {
		height: theme.spacing(5),
		caretColor: "transparent",
	},
	input: {
		padding: theme.spacing(1, 1.5),
		cursor: "pointer",
		"&:disabled": {
			cursor: "not-allowed",
			pointerEvents: "auto",
		},
	},
	clearButton: {
		padding: 0,
		marginRight: theme.spacing(-0.5),
		cursor: "pointer",
		"& svg": {
			width: theme.spacing(2.5),
			height: theme.spacing(2.5),
		},
		"&:hover": {
			backgroundColor: "inherit",
		},
	},
	positionEnd: {
		marginLeft: 0,
	},
}));
